import { QuotationModel } from "@app/authority/authority-op/models/quotation.model";
import { DossierModel } from "../../models/dossier.model";
import { WorkingModel } from "../../models/working.model";

/**
 *  A differenza di Redux originale, lo store non è una generica mappa
 *  ma un'entità, con i relativi metodi SET e GET
 */ 
export class FluxAuthorityStore {
  private dossier: DossierModel;
  private workingList: WorkingModel[];

  // andrebbe inglobata dento alla singola working
  // e il preventivo dovrebbe essere 1 solo
  private quotationList: QuotationModel[];

  constructor(model?: any) {
    
    this.dossier = new DossierModel(model);
    this.workingList = [];
    this.quotationList = [];
  }
  
  /**
   *    INTERVENTO
   */ 
  getDossier(): DossierModel {

    return this.dossier;
  }
  
  setDossier(input: DossierModel): void {

    this.dossier = input;
  }

  
  /**
   *    LISTA PRATICHE
   */ 
  getWorkingList(): WorkingModel[] {

    return this.workingList;
  }
  
  setWorkingList(input: WorkingModel[]): void {

    this.workingList = input; 
  }

  
  /**
   *    LISTA PREVENTIVI
   */ 
  
  getQuotationList(): QuotationModel[] {

    return this.quotationList;
  }
  
  setQuotationList(input: QuotationModel[]): void {

    this.quotationList = input;
  }
}
